import { render, staticRenderFns } from "./allList.vue?vue&type=template&id=ddefda08&scoped=true&"
import script from "./allList.vue?vue&type=script&lang=js&"
export * from "./allList.vue?vue&type=script&lang=js&"
import style0 from "./allList.vue?vue&type=style&index=0&id=ddefda08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddefda08",
  null
  
)

export default component.exports